import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaArrowLeft,
  FaLightbulb,
  FaMapMarkerAlt
} from "react-icons/fa";
import api from "../utils/api";
import "./SuggestionForm.css";

const SuggestionForm = () => {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    category: "",
    title: "",
    description: "",
    location: ""
  });


  const categories = [
    { value: "roads", label: "Roads & Traffic" },
    { value: "cleanliness", label: "Cleanliness & Waste" },
    { value: "water", label: "Water Supply" },
    { value: "street_lights", label: "Street Lights" },
    { value: "parks", label: "Parks & Gardens" },
    { value: "public_safety", label: "Public Safety" },
    { value: "healthcare", label: "Healthcare" },
    { value: "education", label: "Education" },
    { value: "public_transport", label: "Public Transport" },
    { value: "environment", label: "Environment" },
    { value: "digital_services", label: "Digital Services" },
    { value: "other", label: "Other" }
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

 

const handleSubmit = async (e) => {

  e.preventDefault();

  if (
    !formData.category ||
    !formData.title ||
    !formData.description
  ) {
    toast.error("Please complete all required fields.");
    return;
  }

  setLoading(true);

  try {

    const data = new FormData();

    data.append("category", formData.category);
    data.append("title", formData.title);
    data.append("description", formData.description);
    data.append("location", formData.location);

    await api.post("/suggestions", data);

    toast.success("🎉 Thank you! Your suggestion has been submitted.");

    navigate("/dashboard");

  } catch (error) {

    console.error(error);

    toast.error(
      error.response?.data?.message ||
      "Unable to submit suggestion."
    );

  } finally {

    setLoading(false);

  }

};


 return (
  <div className="suggestion-page">

    <div className="suggestion-container">

      {/* Back Button */}

      <button
        className="suggestion-back-btn"
        onClick={() => navigate("/dashboard")}
      >
        <FaArrowLeft /> Back to Dashboard
      </button>

      {/* Header */}

      <div className="suggestion-header">

        <div className="header-icon">
          <FaLightbulb />
        </div>

        <div>
          <h1>Share Your Suggestion</h1>

          <p>
            Have an idea to improve your ward? We'd love to hear it.
            Your suggestions help build a cleaner, safer and smarter city.
          </p>
        </div>

      </div>

      {/* Tips */}

      <div className="suggestion-tip">

        <h3>💡 Good Suggestions Include</h3>

        <ul>
          <li>Install CCTV near public places.</li>
          <li>Plant more trees.</li>
          <li>Add benches in gardens.</li>
          <li>Improve street lighting.</li>
          <li>Increase public dustbins.</li>
        </ul>

      </div>

      <form onSubmit={handleSubmit}>

        {/* Category */}

        <div className="form-group">

          <label>Suggestion Category *</label>

          <select
            name="category"
            className="form-control"
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value="">Select Category</option>

            {categories.map((cat) => (
              <option
                key={cat.value}
                value={cat.value}
              >
                {cat.label}
              </option>
            ))}

          </select>

        </div>

        {/* Title */}

        <div className="form-group">

          <label>Suggestion Title *</label>

          <input
            type="text"
            name="title"
            className="form-control"
            placeholder="Example: Install CCTV Cameras near Market"
            value={formData.title}
            onChange={handleChange}
            maxLength={200}
            required
          />

        </div>

        {/* Description */}

        <div className="form-group">

          <label>Describe Your Idea *</label>

          <textarea
            name="description"
            className="form-control"
            placeholder="Explain your suggestion, why it is needed and how citizens will benefit..."
            value={formData.description}
            onChange={handleChange}
            maxLength={1000}
            required
            style={{ minHeight: "180px" }}
          />

        </div>

        {/* Location */}

        <div className="form-group">

          <label>
            <FaMapMarkerAlt /> Suggested Location (Optional)
          </label>

          <input
            type="text"
            name="location"
            className="form-control"
            placeholder="Example: Ward 5, Near City Hospital"
            value={formData.location}
            onChange={handleChange}
          />

        </div>


        {/* Buttons */}

        <div className="form-actions">

          <button
            type="button"
            className="cancel-btn"
            onClick={() => navigate("/dashboard")}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="submit-btn"
            disabled={loading}
          >
            {loading
              ? "Submitting..."
              : "Share Suggestion"}
          </button>

        </div>

      </form>

    </div>

  </div>
);

};

export default SuggestionForm;